var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "ul",
      { staticClass: "tag-type" },
      _vm._l(_vm.masterEmploymentStatuses, function (masterEmploymentStatus) {
        return _c(
          "li",
          { key: masterEmploymentStatus.id },
          [
            _vm.isContainEmploymentStatus(masterEmploymentStatus.id)
              ? [
                  _c("img", {
                    staticClass: "employment-img",
                    attrs: {
                      src:
                        _vm.userOfferImageUrlForPc +
                        "/" +
                        masterEmploymentStatus.iconName,
                      alt: masterEmploymentStatus.name,
                      "data-test": "employment-" + masterEmploymentStatus.id,
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }